import type React from 'react';
import HdpContentWrapper from 'app/shared/modules/hdp/HdpContentWrapper';
import PpcLink from 'app/shared/modules/hdp/PpcLink';
import Container from 'app/shared/core/Container';
import type { ListingDetails } from 'app/types/listingDetails.type';
import {
  StyledHdpAddressDisplayAddress,
  StyledHdpAddressDisplayName,
  StyledHdpAddressDisplayWrapper,
} from './HdpSummary.styles';

interface HdpAddressV2Props {
  listing: ListingDetails;
}

const HdpAddressV2: React.FC<HdpAddressV2Props> = ({ listing }) => {
  const { displayName, address } = listing;
  const { street, city, state, zip, hideStreet } = address;
  const displayNameHasStreet = displayName.includes(street);
  const displayAddress =
    hideStreet || displayNameHasStreet ? `${city}, ${state} ${zip}` : `${street}, ${city}, ${state} ${zip}`;

  return (
    <div className="HdpAddressV2">
      <HdpContentWrapper fullContent active noBorder noPadding>
        <Container>
          <StyledHdpAddressDisplayWrapper>
            <StyledHdpAddressDisplayName>{displayName}</StyledHdpAddressDisplayName>
          </StyledHdpAddressDisplayWrapper>
          <StyledHdpAddressDisplayAddress>{displayAddress}</StyledHdpAddressDisplayAddress>
          <PpcLink listing={listing} ppcLocation="address" />
        </Container>
      </HdpContentWrapper>
    </div>
  );
};

export default HdpAddressV2;
